export default __webpack_public_path__ + "static/media/SViewIconColor.bd0e7d68.svg";